'use client';
import { useCalendarPickerStyles_unstable } from '../CalendarPicker/useCalendarPickerStyles.styles';
/**
 * Apply styling to the CalendarYear slots based on the state
 *
 * @internal
 */ export const useCalendarYearStyles_unstable = (props)=>{
    'use no memo';
    return useCalendarPickerStyles_unstable(props);
};
